<template>
  <div :class="backgroundColor" class="d-flex jc-between ai-center c-white">
    <div class="d-flex flex-1-1 p-1">
      <vk-icon v-if="!hideIcon" :name="iconName" class="flex-0-0 text-lg m-l-1 m-r-2"/>
      <slot/>
    </div>
    <div v-if="hasClose" class="d-flex ai-center" @click="$emit('close')">
      <vk-icon
          name="close"
          class="cur-pointer flex-0-0 text-lg m-l-1 m-r-2"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'alert-message',
  props: {
    type: {
      type: String,
      required: true,
      validator (value) {
        return ['success', 'error', 'alert'].some(state => state === value);
      },
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    hasClose: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconName () {
      switch (this.type) {
        case 'success':
          return 'checkmark';
        case 'alert':
          return 'alert';
        case 'error':
          return 'exclamation';

        default:
          return 'exclamation';
      }
    },
    backgroundColor () {
      switch (this.type) {
        case 'success':
          return 'bg-green';
        case 'alert':
          return 'bg-gray90';
        case 'error':
          return 'bg-red';

        default:
          return 'bg-red';
      }
    },
  },
};
</script>
